const itemConfig = {
  brandItem: {
      filterLayout: 'ItemFilterBrandLayout',
      listLayout: 'ItemListBrandLayout',
      paginationLayout: 'PaginationBrandLayout',
      listApiParamSet: {
          ip: 1,
          sp: 10,
          page: 1,
          ty:'eot',
          fi:1
      },
      pageRow: 10,
      paginationType: 'pagination',
      getFunc: 'getBrandItem',
  },

}
export default {
  methods: {
      returnItemConfig(type) {
          return itemConfig[type];
      },
  },
  filterConfig: {
      na: { //상품이름
          type: 'query',
          classname: 'searchInput',
      },
      i_model: { //관리코드
          type: 'query',
          classname: 'searchInput',
      },
      pmin: { //가격
        type: 'query',
        classname: 'filterPriceLow',
      },
      pmax: { //가격
        type: 'query',
        classname: 'filterPriceHigh',
      },
      di: {
        type: 'match',
        classname: 'filterDisplay',
      },
      isse: {
        type: 'match',
        classname: 'filterSelling',
      },
      if: {
        type: 'match',
        classname: 'filterFitting',
      },
      co: { //컬러
          type: 'match',
          classname: 'filterColor',
      },
      pat: { //패턴
          type: 'match',
          classname: 'filterPattern',
      },
      ton: { //톤
          type: 'match',
          classname: 'filterTone',
      },
      sea: { //시즌
          type: 'match',
          classname: 'filterSeason',
      },
      main: { // 대표상품
        type: 'match',
        classname: 'filterRepresentative',
    },
      ca1: { //상품분류 첫번째
          type: 'match',
          classname: 'filterCateDepth1',
          option: {ela_dataField: 'category.level1', type: 'itemCategory', depth: 1}
      },
      ca2: { //상품분류 두번째
          type: 'match',
          classname: 'filterCateDepth2',
          option: {ela_dataField: 'category.level2', type: 'itemCategory', depth: 2}
      },
      ca3: { //상품분류 세번째
          type: 'match',
          classname: 'filterCateDepth3',
          option: {ela_dataField: 'category.level3', type: 'itemCategory', depth: 3}
      },
      ca4: { //상품분류 네번째
          type: 'match',
          classname: 'filterCateDepth4',
          option: {ela_dataField: 'category.level4', type: 'itemCategory', depth: 4}
      },
      cr: { //등록일
          type: 'between',
          classname: 'filterDate',
          option: {ela_dataField: 'created_at'},
      },
      tab: {
          type: 'noFilter',
          classname: 'tab',
      },
  },
}
